const { createContext, useState, useContext } = require("react");

export const SettingContext = createContext();

export const SettingProvider = ({ children }) => {
  const [createBtn, setCreateBtn] = useState(false);
  const [creatBtnName, setCreateBtnName] = useState("");
  const [createRole, setCreateRole] = useState(false);
  const [roleEditBtn, setRoleEditBtn] = useState(false);
  const [isDltClick, setIsDltClick] = useState(false);
  const [undoRole, setUndoRole] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [cancelEditUserModal, setCancelEditUserModal] = useState(false);
  const [cancelEditChnages, setCancelEditChanges] = useState(false);

  const [openEditPage, setOpenEditPage] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isNameChanged, setIsNameChanged] = useState(false);

  const [restrictBtn, setRestrictBtn] = useState(false);
  const [isRestrictedData, setIsRestrictedData] = useState([]);
  const [isRestrictModalOpen, setIsRestrictModalOpen] = useState(false);

  // Right and Limit Page State
  const [isRightPage, setIsRightPage] = useState(false);
  const [userCreateStatus, setUserCreatedStatus] = useState(false);
  const [userCreateMessage, setUserCreateMessage] = useState(null);
  const [userEditStatus, setUserEditStatus] = useState(false);
  const [userEditMessage, setUserEditMessage] = useState(null);
  const [selectRoleBtnName, setSelectRoleBtnName] = useState(localStorage.getItem("roleButtonName") || "Select Role");
  const [selectRoleOptions, setSelectRoleOptions] = useState([]);
  const [enableSaveRightsBtn, setEnableSaveRightsBtn] = useState(false);
  const [vibrateButton, setVibrateButton] = useState(false);
  const [saveRightModalOpen, setSaveRightModalOpen] = useState(false);

  // Limit Page State
  const [isLimitPage, setIsLimitPage] = useState(false);
  const [enableSaveLimitsBtn, setEnableSaveLimitsBtn] = useState(false);
  // const [saveLimitModalOpen, setSaveLimitModalOpen] = useState(false);

  //for the missing img count
  const [missingImagesCount, setMissingImagesCount] = useState(null);
  const [missingImagesModal, setMissingImagesModal] = useState(false);

  //for restricate categorData
  const [restricateCatagoryCount, setRestricateCatagoryCount] = useState(null);
  const [syncCount, setSyncCount] = useState(null);
  const [syncSubPageCount, setSyncSubPageCount] = useState(0);

  const [search, setSearch] = useState("");
  const [searchBar, setSearchBar] = useState(false);

  //for sync page
  const [syncButton, setSyncButton] = useState(false);
  const [syncModal, setSyncModal] = useState(false);
  const [ReverAlltModal, setRevertAllModal] = useState(false);
  const [singleRevertModal, setSingleRevertModal] = useState(false);
  const [syncButtonName, setSyncButtonName] = useState(null);
  const [revertPermission, setRevertPermission] = useState(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [designCount, setDesignCount] = useState(0);

  const [rateMaster, setRateMaster] = useState(false);
  const [waba, setWaba] = useState(false);

  const [addClient, setAddClient] = useState(false);

  //for USP Modal
  const [addModalOpen, setAddModalOpen] = useState(false);

  // For Stock Tray
  const [editTrayData, setEditTrayData] = useState(null);

  // For My Binnys Report

  const [myBinnysReport, setMyBinnysReport] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  const [userCreateBtn, setUserCreateBtn] = useState(false);
  const [usercreatBtnName, setUsercreatBtnName] = useState(null);
  const [onSave, setOnSave] = useState(() => () => {});

  return (
    <SettingContext.Provider
      value={{
        createBtn,
        setCreateBtn,
        creatBtnName,
        setCreateBtnName,
        createRole,
        setCreateRole,
        roleEditBtn,
        setRoleEditBtn,
        openEditPage,
        setOpenEditPage,
        isDltClick,
        setIsDltClick,
        isUpdate,
        setIsUpdate,

        undoRole,
        setUndoRole,
        isChange,
        setIsChange,
        cancelEditUserModal,
        setCancelEditUserModal,
        cancelEditChnages,
        setCancelEditChanges,

        isRightPage,
        setIsRightPage,
        userCreateStatus,
        setUserCreatedStatus,

        userCreateMessage,
        setUserCreateMessage,

        userEditStatus,
        setUserEditStatus,

        userEditMessage,
        setUserEditMessage,

        selectRoleBtnName,
        setSelectRoleBtnName,

        selectRoleOptions,
        setSelectRoleOptions,

        enableSaveRightsBtn,
        setEnableSaveRightsBtn,

        vibrateButton,
        setVibrateButton,

        saveRightModalOpen,
        setSaveRightModalOpen,

        isLimitPage,
        setIsLimitPage,

        enableSaveLimitsBtn,
        setEnableSaveLimitsBtn,

        isNameChanged,
        setIsNameChanged,
        missingImagesCount,
        setMissingImagesCount,
        missingImagesModal,
        setMissingImagesModal,
        search,
        setSearch,

        restrictBtn,
        setRestrictBtn,

        isRestrictedData,
        setIsRestrictedData,

        isRestrictModalOpen,
        setIsRestrictModalOpen,

        syncButton,
        setSyncButton,

        syncModal,
        setSyncModal,

        syncButtonName,
        setSyncButtonName,

        singleRevertModal,
        setSingleRevertModal,

        ReverAlltModal,
        setRevertAllModal,

        revertPermission,
        setRevertPermission,

        restricateCatagoryCount,
        setRestricateCatagoryCount,

        openImageModal,
        setOpenImageModal,

        designCount,
        setDesignCount,
        searchBar,
        setSearchBar,

        rateMaster,
        setRateMaster,

        waba,
        setWaba,

        syncCount,
        setSyncCount,

        syncSubPageCount,
        setSyncSubPageCount,

        addClient,
        setAddClient,

        addModalOpen,
        setAddModalOpen,

        editTrayData,
        setEditTrayData,

        myBinnysReport,
        setMyBinnysReport,

        searchTerm,
        setSearchTerm,
        isDisable,
        setIsDisable,

        userCreateBtn,
        setUserCreateBtn,

        setUsercreatBtnName,
        usercreatBtnName,
        onSave,
        setOnSave,
      }}
    >
      {children}
    </SettingContext.Provider>
  );
};

export const useSettingContext = () => useContext(SettingContext);
